const PREFIX = 'eos7_';

export const STORAGE_KEYS = {
  CUSTOMERS: `${PREFIX}customers`,
  STAFF: `${PREFIX}staff`,
  WORK_ORDERS: `${PREFIX}workOrders`,
  INVENTORY: `${PREFIX}inventory`,
  TRANSACTIONS: `${PREFIX}transactions`
};

class StorageService {
  get(key) {
    try {
      const data = localStorage.getItem(key);
      return data ? JSON.parse(data) : [];
    } catch {
      return [];
    }
  }

  set(key, data) {
    try {
      localStorage.setItem(key, JSON.stringify(data));
      return true;
    } catch {
      return false;
    }
  }

  getById(key, id) {
    return this.get(key).find(item => item.id === id);
  }

  add(key, item) {
    const items = this.get(key);
    items.push(item);
    this.set(key, items);
    return item;
  }

  update(key, id, updates) {
    const items = this.get(key);
    const index = items.findIndex(item => item.id === id);
    if (index === -1) return null;
    
    items[index] = { ...items[index], ...updates, updatedAt: new Date().toISOString() };
    this.set(key, items);
    return items[index];
  }

  delete(key, id) {
    const items = this.get(key);
    const filtered = items.filter(item => item.id !== id);
    this.set(key, filtered);
    return true;
  }

  seedIfEmpty(key, seedData) {
    const existing = this.get(key);
    if (existing.length === 0 && seedData.length > 0) {
      this.set(key, seedData);
      return seedData;
    }
    return existing;
  }
}

export const storage = new StorageService();